import { Configuration as ConfSaci, ApiApi } from '@/shared/saci';

const saciConfiguration = new ConfSaci({
  basePath: '/services/saci',
});

const saciApi = new ApiApi(saciConfiguration);

export { saciApi };
